"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _label = _interopRequireDefault(require("./label"));

var _errorMessage = _interopRequireDefault(require("./error-message"));

var _classnames = _interopRequireDefault(require("classnames"));

var _checkboxModule = _interopRequireDefault(require("./checkbox.module.scss"));

var _textfieldModule = _interopRequireDefault(require("./textfield.module.scss"));

var _field = require("./field");

var _fieldsize = _interopRequireWildcard(require("./fieldsize"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Checkbox = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Checkbox, _Component);

  var _super = _createSuper(Checkbox);

  function Checkbox() {
    var _this;

    (0, _classCallCheck2.default)(this, Checkbox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      checked: _this.props.checked
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onClickOrChange", function () {
      if (_this.props.onChange) {
        _this.props.onChange(!_this.state.checked);
      } else {
        _this.setState(function (state) {
          return {
            checked: !state.checked
          };
        });
      }
    });
    return _this;
  }

  (0, _createClass2.default)(Checkbox, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.checked !== undefined && prevProps.checked !== this.props.checked) {
        this.setState(function (_state, props) {
          return {
            checked: props.checked
          };
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var id = this.props.id || (0, _field.makeIdString)();
      var inputAttributes = {
        type: 'checkbox',
        className: (0, _classnames.default)(_checkboxModule.default.field, (0, _defineProperty2.default)({}, _checkboxModule.default.fieldSmall, this.props.size === _fieldsize.default.SMALL), (0, _defineProperty2.default)({}, _checkboxModule.default.fieldInvalid, this.props.errorMessage), this.props.classNames.field),
        id: id,
        'data-test-id': this.props.dataTestId,
        disabled: this.props.disabled,
        'aria-label': this.props.ariaLabel,
        onBlur: this.props.onBlur,
        name: this.props.name,
        ref: this.props.innerRef
      };

      if (this.props.onChange) {
        inputAttributes.checked = this.props.checked;
        inputAttributes.onChange = this.onClickOrChange;
      } else {
        inputAttributes.defaultChecked = this.props.checked;
        inputAttributes.onClick = this.onClickOrChange;
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(_checkboxModule.default.Checkbox, this.props.classNames.wrapper, (0, _defineProperty2.default)({}, _checkboxModule.default.disabled, this.props.disabled))
      }, /*#__PURE__*/_react.default.createElement("input", inputAttributes), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_label.default, {
        size: this.props.size,
        className: (0, _classnames.default)(this.props.classNames.label, (0, _defineProperty2.default)({}, _textfieldModule.default.errorLabel, this.props.errorMessage)),
        for: id
      }, this.props.label), this.props.errorMessage && /*#__PURE__*/_react.default.createElement(_errorMessage.default, {
        size: this.props.size,
        message: this.props.errorMessage,
        className: this.props.classNames.errorMessage
      })));
    }
  }]);
  return Checkbox;
}(_react.Component);

exports.default = Checkbox;
Checkbox.propTypes = _objectSpread(_objectSpread(_objectSpread({}, _field.fieldPropTypes), _fieldsize.fieldSizePropTypes), {}, {
  checked: _propTypes.default.bool
});
Checkbox.defaultProps = _objectSpread(_objectSpread({
  checked: false
}, _fieldsize.fieldSizeDefaultProps), {}, {
  classNames: {}
});